export default time => time.toString().padStart(2, '0')
